import React, { useState, useEffect, useCallback } from "react";
import Button from "../Button";
import Tooltip2 from "../Tooltip";
import IcClip from "../Svg/IcClip";
import { useDropzone } from "react-dropzone";
import style from "./style.module.scss";

export default function FileUpload(props) {
  const { files, setfiles, loading, label } = props;

  const [fileDroped, setfileDroped] = useState();
  const onDropFile = useCallback(__files => {
    setfileDroped(
      __files.map(e =>
        Object.assign(e, {
          preview: URL.createObjectURL(e),
        }),
      ),
    );
  }, []);

  useEffect(() => {
    if (!!fileDroped) {
      const _files = (files || []).concat(fileDroped);
      setfiles(_files);
    }
  }, [fileDroped]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: true,
    maxFilesize: 20971520, // 20 MB
    onDrop: onDropFile,
  });

  return (
    <div className={style.container}>
      <Button loading={!!loading} type="submit" onClick={() => {}} {...getRootProps()} title="Anexar Arquivos">
        <input {...getInputProps()} />
        <IcClip />

        {!!label && <span className="ml-2">{label}</span>}
      </Button>
      <div className={style.files}>
        {files?.map((__file, __i) => (
          <span className={style.file}>
            <span className={style.name}>{__file?.name}</span>
            <span
              className={style.remove_file}
              onClick={() => {
                console.log("pre _files", files);
                let _files = [...files];
                _files.splice(__i, 1);
                console.log("post _files", _files);
                setfiles(_files);
              }}
            >
              X
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
